import { __awaiter } from "tslib";
import { createAsyncThunk, createSelector, createSlice } from '@reduxjs/toolkit';
import { ReducerType } from '../types';
import { MISSING_CUSTOMER } from '@open-tender/types';
import { checkAuth, selectToken } from './account';
import { showNotification } from '../notifications';
const initialState = {
    entity: null,
    error: null,
    loading: 'idle'
};
export var CustomerOrderActionType;
(function (CustomerOrderActionType) {
    CustomerOrderActionType["FetchCustomerOrder"] = "customer/fetchCustomerOrder";
    CustomerOrderActionType["UpdateCustomerOrderRating"] = "customer/updateCustomerOrderRating";
})(CustomerOrderActionType || (CustomerOrderActionType = {}));
export const fetchCustomerOrder = createAsyncThunk(CustomerOrderActionType.FetchCustomerOrder, (orderId, { dispatch, getState, rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const api = getState().config.api;
        const token = selectToken(getState());
        if (!token)
            throw new Error(MISSING_CUSTOMER);
        const order = yield api.getCustomerOrder(token, orderId);
        return order;
    }
    catch (err) {
        const error = err;
        return checkAuth(error, dispatch, () => rejectWithValue(error));
    }
}));
export const updateCustomerOrderRating = createAsyncThunk(CustomerOrderActionType.UpdateCustomerOrderRating, ({ orderId, data }, { dispatch, getState, rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const api = getState().config.api;
        const token = selectToken(getState());
        if (!token)
            throw new Error(MISSING_CUSTOMER);
        yield api.putCustomerOrderRating(token, orderId, data);
        dispatch(fetchCustomerOrder(orderId));
        dispatch(showNotification('Rating updated!'));
    }
    catch (err) {
        const error = err;
        return checkAuth(error, dispatch, () => rejectWithValue(error));
    }
}));
const customerOrderSlice = createSlice({
    name: ReducerType.Order,
    initialState,
    reducers: {
        resetCustomerOrder: () => initialState,
        resetCustomerOrderError: state => {
            state.error = null;
            state.loading = 'idle';
        },
        setCustomerOrder: (state, action) => {
            state.entity = action.payload;
            state.error = null;
        }
    },
    extraReducers: builder => {
        builder
            .addCase(fetchCustomerOrder.fulfilled, (state, action) => {
            state.entity = action.payload;
            state.loading = 'idle';
            state.error = null;
        })
            .addCase(fetchCustomerOrder.pending, state => {
            state.loading = 'pending';
        })
            .addCase(fetchCustomerOrder.rejected, (state, action) => {
            state.error = action.payload;
            state.loading = 'idle';
        })
            .addCase(updateCustomerOrderRating.fulfilled, state => {
            state.loading = 'idle';
            state.error = null;
        })
            .addCase(updateCustomerOrderRating.pending, state => {
            state.loading = 'pending';
        })
            .addCase(updateCustomerOrderRating.rejected, (state, action) => {
            state.error = action.payload;
            state.loading = 'idle';
        });
    }
});
export const { resetCustomerOrder, resetCustomerOrderError, setCustomerOrder } = customerOrderSlice.actions;
export const selectCustomerOrder = createSelector((state) => {
    const { entity: order, loading, error } = state.customer.order;
    return { order, loading, error };
}, ({ order, loading, error }) => {
    return { order, loading, error };
});
export const customerOrderReducer = customerOrderSlice.reducer;
